import { required, integer, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    branch: {
      id: {
        required: helpers.withMessage(i18n.global.t('Please select branch.'), required),
        integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer)
      },
      is_in_stock: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required)
      }
    }
  }
};
